import React from 'react';
import { Flex, Box, AccordionButton, AccordionItem, AccordionIcon, AccordionPanel, Text } from '@chakra-ui/react';
import { cssVariables } from '../../../redux/cssVariablesSlice';
import { useSelector, useDispatch } from 'react-redux';
import CssEditorColorPicker from './CssEditorColorPicker';

const CssEditorColors = ({ editableVar, title }) => {
	const cssVar = useSelector(cssVariables);

	if (!cssVar) return null;
	return (
		<AccordionItem overflow={'visible'}>
			<AccordionButton justifyContent={'space-between'}>
				<Text>{title}</Text>
				<AccordionIcon />
			</AccordionButton>
			<AccordionPanel overflow={'visible'}>
				<Box p={2} overflow={'visible'}>
					<Flex flexDir="column" sx={{ gap: '1px' }} overflow={'visible'}>
						{Object.keys(cssVar)
							.map((varName, index) => {
								if (editableVar.find((el) => el == varName)) {
									return <CssEditorColorPicker key={'CEColorPicker-' + index} {...{ varName }} />;
								}
							})
							.filter((el) => el)}
					</Flex>
				</Box>
			</AccordionPanel>
		</AccordionItem>
	);
};

export default CssEditorColors;
